import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { ApiService } from '@app/utility/api.service'
import { UtilService } from '@app/utility/util.service'
import { truncate } from 'lodash';
import { Observable, Subscription } from 'rxjs';

declare var $: any

@Component({
  selector: 'app-customer-req-doc',
  templateUrl: './customer-req-doc.component.html',
  styleUrls: ['./customer-req-doc.component.scss']
})
export class CustomerReqDocComponent implements OnInit {

  contactId = "";
  contact: any = {};
  combinedAddressList: any;

  disablebtnSave  = false;
  isCheckedAll = false;
  selectList: any;
  contactDrosD03List: any = [];
  mobileOTPDrosD02 = "";
  UIDD02 = "";
  lastReqTime: any
  disableResentOtp = false
  totolWaitResend = 59

  otp = ""
  otpRef = ""
  requestOtpLbl = "ส่ง"
  otpTimer: any = ""

  ElapseTime: number = 0;
  TotalTime: number = 0;
  OTPCountDown: string = "";
  SubScr: Subscription;

  displayStyle = "none";

  otpmobile = "";
  verifyOtp = "";

  mobilenomasking = "";
  mobilemasking = "";

  submitted = false;

  constructor(private apiService: ApiService,
    private util: UtilService,
    private fb: FormBuilder,
    private activatedRoute: ActivatedRoute) { }

  async ngOnInit() {

  }

  async init(id: string) {
    const thisTs = this
    function matchCustom(params: any, data: any) {

      // If there are no search terms, return all of the data
      if ($.trim(params.term) === '') {
        return data;
      }

      // Do not display the item if there is no 'text' property
      if (typeof data.text === 'undefined') {
        return null;
      }

      if (params.term.length > 1) {
        // `params.term` should be the term that is used for searching
        // `data.text` is the text that is displayed for the data object
        if (data.text.indexOf(params.term) > -1) {
          // You can return modified objects from here
          // This includes matching the `children` how you want in nested data sets
          return data;
        }
      }
      // Return `null` if the term should not be displayed
      return null;
    }

      this.contactId = this.activatedRoute.snapshot.paramMap.get('id');
      this.util.ShowWaiting(true)

      await this.initData();
      $('.select2').select2({
        // matcher: function (term: any, text: any, option: any) {
        //   return option.hasClass('car');
        // }
        matcher: matchCustom
      });

      $(".select2").on("change", function (e: any) {
        thisTs.addressChange(e.target.value)
      })


      this.util.ShowWaiting(false)

  }

  onCheckAllChange() {
    $(".row-checker").prop("checked", this.isCheckedAll)
  }

  getSelectedContact() {
    let thisTs = this
    this.selectList = []
    $('.row-checker:checkbox:checked').each(function () {
      let value = {
        RequestedNo: $(this).val()
      }
      thisTs.selectList.push(value);
    })
  }

  async initData() {
    this.combinedAddressList = await this.apiService.getMasterAddress();
    this.contact = await this.getContact();
    if (this.contact.dpa_companytypeid != null && this.contact.dpa_companytypeid.trim().length > 0)
    {
      await this.getDrosContact(this.contact.dpa_registrationid);
    }
    else
    {
      await this.getDrosContact(this.contact.dpa_idcard);
    }
  }

  async getContact() {
    let para = "contactid=" + this.contactId
    let tmp: any = await this.apiService.get("crmservice", "contact", para)
    return tmp[0]
  }

  async getDrosContact(phoneNo: string){
    let para = "CRM02=true&CRM03=true"
  
    if(phoneNo != null && phoneNo.trim().length != 0){
      para += "&dpa_id=" + phoneNo
    }

    if(para == "CRM02=true&CRM03=true"){
      return
    }
    else{
      
      let contactDros: any = await this.apiService.get("crmservice", "contactDros", para);

      if(contactDros == null || contactDros.length == 0){
        this.util.WarningDialog("ไม่พบข้อมูลใน DROS")
      }
      else{
        let hasRow = false;
        if(contactDros != null && contactDros.CRM03 != null){

          if (!this.util.IsNullOrUndefined(contactDros.CRM03)) {
            if (this.contactDrosD03List.length == 0){
              for (let itm of contactDros.CRM03) {
                if (!this.util.IsNullOrUndefined(itm.FilePath)) {  
                   
                    if(itm.FilePath.split('_')[1] != "05.pdf" && itm.FilePath.split('_')[1] != "07.pdf" )
                    {
                          if(itm.IsPrint != 1)
                          {
                            hasRow = true;
                          }
  
                          let reqdetail: any = { 
                            RequestedNo: itm.RequestedNo, 
                            RequestType : itm.RequestType,
                            StatusDefinition : itm.StatusDefinition,
                            isPrintMessage : itm.IsPrint == 1 ? "มีการขอเอกสารแล้ว" : ("สามารถขอเอกสารได้"),
                            UID : itm.UID,
                            isPrint : itm.IsPrint,
                
                          }
                          
                            this.contactDrosD03List.push(reqdetail);
                          
                            
                    }
                }
              }
            }
            
          }
          if(!hasRow)
          {
            this.disablebtnSave = true;
            //$("#savedata").addClass("sr-only");
          }

         //this.contactDrosD03List = contactDros.CRM03.filter((mb: any) => {
            //return mb.FilePath != null &&  mb.FilePath != ""})

          //this.contactDrosD03List = contactDros.CRM03;
        }

        
    if (!this.util.IsNullOrUndefined(this.contactDrosD03List) && this.contactDrosD03List.length == 0) {
      $("#divNoData").removeClass("colhidden");  
     // $("#savedata").addClass("sr-only");
      this.disablebtnSave = true;
    }

        if(contactDros != null && contactDros.CRM02 != null){
          this.mobileOTPDrosD02 = this.contact.telephone1;
          this.UIDD02 = contactDros.CRM02[0].UID; 
          
          this.maskingMobile(this.mobileOTPDrosD02,6);
        }
      }
    }
  }

  async requestOtp() {
    
    this.otpmobile = this.mobilenomasking;
    if(this.mobilemasking.indexOf("x") == -1)
    {
      //console.log("1")
      this.otpmobile = this.mobilemasking;
      //console.log(this.otpmobile)
    }
    else
    {
      
      //console.log("2")
      this.otpmobile = this.mobilenomasking;
      //console.log(this.otpmobile)
    }

    if(this.otpmobile.length < 10)
    {
      this.util.ErrorDialog("กรุณากรอกหมายเลขโทรศัพท์ที่ถูกต้อง")
      return;
    } 

    let reqOtp: any = {
      MobileNo: this.otpmobile,
    }

    await this.apiService.postCustom("crm", "RequestOTP", reqOtp).then(async (reqOtpRes: any) => {
      if (this.util.isSuccessResponse(reqOtpRes)) {

        this.otpRef = reqOtpRes.RefCode;

        let smsContent = "รหัสตรวจสอบการยืนยันตัวตนของคุณคือ : "
        smsContent += reqOtpRes.otpNo + " "
        smsContent += "(RefCode : " +reqOtpRes.RefCode  
        smsContent += ") (รหัสมีอายุ " + reqOtpRes.expInMinute + " นาที) อย่าเปิดเผยรหัสกับผู้อื่น"   


        let sendSms: any = {
          dpa_description: smsContent,
          dpa_phoneno: this.otpmobile
        }
        let sendSmsRes: any = await this.apiService.post("crmservice", "sendSms", sendSms)

        if (this.util.isSuccessResponse(sendSmsRes)) {
          this.otpRef = reqOtpRes.RefCode
          this.otpTimer = 59
          this.lastReqTime = new Date()
          this.requestOtpLbl = "ส่งอีกครั้ง"
          this.disableResentOtp = true
          
          if (reqOtpRes.expInMinute == undefined || reqOtpRes.expInMinute == null) {
            this.TotalTime = 300;
          }
          else {
            this.TotalTime = reqOtpRes.expInMinute * 60;
          }
          this.ElapseTime = 0;
          if (this.SubScr != undefined) {
            this.SubScr.unsubscribe();
          }
          //this.SubScr = timer(0, 1000).subscribe(() => this.CountDownOTP());
        }
        else {
          this.util.ErrorDialog("เกิดข้อผิดพลาดในการ ขอ Otp กรุณาลองใหม่อีกครั้ง หรือติดต่อเจ้าหน้าที่")
        }
      }
      else {
        this.util.ErrorDialog("เกิดข้อผิดพลาดในการ ขอ Otp กรุณาลองใหม่อีกครั้ง หรือติดต่อเจ้าหน้าที่")
      }
    })
  }

  async verify() {

    //this.updateCRM08DROS(this.contact);

    if (this.verifyOtp.trim().length > 0) {

      
      this.util.ShowWaiting(true)

      let reqCheckOtp: any = {
        OTP: this.verifyOtp.trim(),
        RefCode: this.otpRef,
        MobileNo: this.otpmobile
      }

      let reqCheckOtpRes: any = await this.apiService.postCustom("crm", "VerifyOTP", reqCheckOtp)
      if (this.util.isSuccessResponse(reqCheckOtpRes)) {
        if (reqCheckOtpRes.IsValid) {
            //update ข้อมูลผ่าน api updateCRM08DROS 
            this.updateCRM08DROS(this.contact); 
            this.util.ShowWaiting(false)
            //this.util.SuccessDialog("ขอเอกสารสำเร็จ");
        }
        else {
          
          this.util.ShowWaiting(false)
          this.util.WarningDialog("รหัส OTP ที่ท่านกรอกไม่ถูกต้อง");
        }
      }
      else { 
        this.util.ShowWaiting(false)
        this.util.WarningDialog("พบข้อผิดพลาดในการยืนยันรหัส OTP กรูณาลองใหม่อีกครั้งหรือติดต่อเจ้าหน้าที่");
      }
    }
    else{
      this.util.WarningDialog("กรุณากรอกรหัส OTP");
    }
  }

  async openstatus(drosReqNo: string) {
 
    let para = "UID=" + this.UIDD02;
    let tmp: any = await this.apiService.get("crmservice", "getCRM08DROS", para); 
    let objDetail: any = tmp.find((e: { DROSRequestNo: string; }) => e.DROSRequestNo === drosReqNo);
    let docStatus = "";
    if(!this.util.IsNullOrUndefined(objDetail.ErrorMessage))
    {
      this.util.WarningDialog(objDetail.ErrorMessage); 
    }
    else{
      if (objDetail.SentStatus === "1") { docStatus = "ดำเนินการจัดส่งเอกสารแล้ว" }
      else if (objDetail.PrintStatus === "1") { docStatus = "อยู่ระหว่างการจัดทำเอกสาร" }
      else if (objDetail.IsRead === "1") { docStatus = "ได้รับคำขอ" }
      else { docStatus = "สร้างรายการ" }
      this.util.WarningDialog("สถานะการขอเอกสารล่าสุด " + docStatus + " เมื่อวันที่ : "  + this.util.transformDate(objDetail.ModifiedOn, "short"));
    }
    
  }

  async updateCRM08DROS(inputcontact: any) {

    let that = this;
    let req: any;
    req = [];

    let RequestedNoList: any;
    RequestedNoList = []; 

    try {

      $('.row-checker:checkbox:checked').each(function () {
        let value = {
          DROSRequestNo: $(this).val(),
          UID : that.UIDD02,
          Status : "P",
          Address : inputcontact.dpa_contact_homeno,
          MooNo : inputcontact.dpa_contact_moo,
          StreetName : inputcontact.dpa_contact_street,
          LocationCode : inputcontact.dpa_contact_subdistict,
          Zipcode : inputcontact.dpa_contact_postcodename,
          PhoneNo : that.otpmobile,
        }

        RequestedNoList.push(value);

      })

      let Res = await this.apiService.post("crmservice", "updateCRM08DROS", RequestedNoList);
      if (Res != null && Res["Status"] != null && parseInt(Res["Status"]) == 200) {
        this.displayStyle = "none";
        this.otpRef = "";
        this.verifyOtp ="";
        this.disableResentOtp = false 
        that.util.SuccessDialog("ขอเอกสารสำเร็จ") 
      }
      else if (Res != null && Res["Status"] != null && parseInt(Res["Status"]) == 201)
      {
        this.displayStyle = "none";
        this.otpRef = "";
        this.verifyOtp ="";
        this.disableResentOtp = false 
        this.util.WarningDialog("บันทึกข้อมูลไม่สำเร็จ มีคำขอซ้ำในระบบ")
      }
      else
      {
        this.displayStyle = "none";
        this.otpRef = "";
        this.verifyOtp ="";
        this.disableResentOtp = false
        that.util.ErrorDialog("ขอเอกสารไม่สำเร็จ")
      }
 

    }
    catch (e) {
      console.error(e)
    }
  }

  maskingMobile(tel: string, digittomask: number)
  {
    if(tel)
    {
      let telonmask = tel.substring(digittomask,tel.length);

      let xmark = "";
      for (let i = 0; i < digittomask; i++) {
        xmark = xmark + "x";
      }

      this.mobilenomasking = tel;
      this.mobilemasking = xmark + telonmask;
    }
    else{
      this.mobilenomasking = tel;
      this.mobilemasking = tel;
    }

  }

  isFormValid() {
    if(this.contact.firstname == null){
      this.contact.firstname = ""
    }
    if(this.contact.lastname == null){
      this.contact.lastname = ""
    }
    if(this.contact.dpa_contact_homeno == null){
      this.contact.dpa_contact_homeno = ""
    }
    if(this.contact.dpa_contact_subdistictname == null){
      this.contact.dpa_contact_subdistictname = ""
    }

    if(this.contact.dpa_contact_distictname == null){
      this.contact.dpa_contact_distictname = ""
    }

    if(this.contact.dpa_contact_provincname == null){
      this.contact.dpa_contact_provincname = ""
    }

    if(this.contact.dpa_contact_postcodename == null){
      this.contact.dpa_contact_postcodename = ""
    }

    return this.contact.firstname != "" &&
      this.contact.firstname.trim().length > 0 &&
      this.contact.dpa_contact_homeno != "" &&
      this.contact.dpa_contact_homeno.trim().length > 0 &&
      this.contact.dpa_contact_subdistictname != "" &&
      this.contact.dpa_contact_subdistictname.trim().length > 0 &&
      this.contact.dpa_contact_distictname != "" &&
      this.contact.dpa_contact_distictname.trim().length > 0 &&
      this.contact.dpa_contact_provincname != "" &&
      this.contact.dpa_contact_provincname.trim().length > 0 &&
      this.contact.dpa_contact_postcodename != "" &&
      this.contact.dpa_contact_postcodename.trim().length > 0
  }

  addressChange(value: any) {
    let selected = this.combinedAddressList.filter((a: any) => a.id == value)
    if (selected != null && selected.length > 0) {
      let values = selected[0].id.split("|")
      let texts = selected[0].text.split(" | ")

      this.contact.dpa_contact_subdistict = values[0]
      this.contact.dpa_contact_distict = values[1]
      this.contact.dpa_contact_province = values[2]
      this.contact.dpa_contact_postcode = values[3]
      this.contact.dpa_contact_country = values[4]

      this.contact.dpa_contact_subdistictname = texts[0]
      this.contact.dpa_contact_distictname = texts[1]
      this.contact.dpa_contact_provincname = texts[2]
      this.contact.dpa_contact_postcodename = texts[3]
      this.contact.dpa_contact_countryname = texts[4]
    }
    else {
      this.contact.dpa_contact_subdistict = ""
      this.contact.dpa_contact_distict = ""
      this.contact.dpa_contact_province = ""
      this.contact.dpa_contact_postcode = ""
      this.contact.dpa_contact_country = ""

      this.contact.dpa_contact_subdistictname = ""
      this.contact.dpa_contact_distictname = ""
      this.contact.dpa_contact_provincname = ""
      this.contact.dpa_contact_postcodename = ""
      this.contact.dpa_contact_countryname = ""
    }
  }

  save() {
    this.submitted = true;

    if (this.isFormValid()) {

      this.getSelectedContact()
      if (this.selectList.length < 1) {
        this.util.WarningDialog("กรุณาเลือกอย่างน้อย 1 รายการ");
      }
      else {
      this.displayStyle = "block";
      }
    }
  }

  close() {
    this.displayStyle = "none";
    this.otpRef = "";
    this.verifyOtp ="";
    this.disableResentOtp = false 
  }

}



// WEBPACK FOOTER //
// ./src/app/customer-req-doc/customer-req-doc.component.ts